import events from 'events.js';

export default async function setupSentry(Sentry, customTags = {}) {
    await events.ready();

    // Considering events.ready() has finished, document.body should be present at this point
    // No sense in configuring scope without document.body
    // since all the scope values are and will be added to document.body
    if (!document.body) {
        return;
    }

    // Cache the value when we know document.body exists
    // avoids getAttribute to be called inside the eventProcessor callback
    // which could happen later in time when document.body doesn't exists anymore.
    const environment = document.body.getAttribute('data-environment');

    Sentry.configureScope((scope) => {
        Object.entries(customTags).forEach(([tagName, tagValue]) => {
            Sentry.setTag(tagName, tagValue);
        });
        scope.addEventProcessor((event) =>
            Promise.resolve({
                ...event,
                environment: environment,
            }),
        );
    });
}
